import { PushPin as MuiPushPinIcon } from '@mui/icons-material';

import type { IconProps } from './icon-props';
import { getIconColorProps, IconDefaults } from './icon-props';

export const PushPinIcon = ({
  fontSize = IconDefaults.fontSize,
  color = IconDefaults.color,
  sx,
  className,
  style,
  onClick
}: IconProps) => {
  const { color: finalColor, sx: finalSx } = getIconColorProps(color, sx);

  return (
    <MuiPushPinIcon
      fontSize={fontSize}
      color={finalColor}
      sx={finalSx}
      className={className}
      style={style}
      onClick={onClick}
    />
  );
};
